import { useGeckoLocale } from 'features/locale'
import { GeckoMeasurementUnit } from 'types'

import { toDisplayValue, toStoredValue } from './zoneUnits'

/**
 * Zone value conversions shown in the measurement toggle's preferred unit for
 * each stored unit. Not for damage mechanism rates: those display in mils per
 * year under imperial, which the preferred unit for mm/y (in/yr) is not.
 */
export const useZoneUnitConversion = () => {
  const { getPreferredMeasurementUnit } = useGeckoLocale()
  return {
    toDisplay: (value: number | undefined, stored: GeckoMeasurementUnit) =>
      toDisplayValue(value, stored, getPreferredMeasurementUnit(stored)),
    toStored: (value: number | null, stored: GeckoMeasurementUnit) =>
      toStoredValue(value, stored, getPreferredMeasurementUnit(stored)),
  }
}
